module.exports = "/assets/data/04d0d81aaeab4b77c31f73020f186afa-BT18.data.json";